<a
  class="text-base flex items-center px-6 py-2 ltr:rounded-r-full rtl:rounded-l-full ltr:mr-6 rtl:ml-6 relative mb-2 transition ease-in-out duration-200 select-none"
  [ngClass]="{ active: active }"
  href="javascript:void(0)"
  matRipple>
  <mat-icon [svgIcon]="link.icon" class="block ltr:mr-4 rtl:ml-4"></mat-icon>
  <span class="block flex-1">{{ link.label }}</span>
  <span
    *ngIf="unread > 0"
    class="mail-sidenav-link__badge ml-3 rounded-full px-2 py-0.5 text-xs font-semibold">
    {{ unread }}
  </span>
  <span *ngIf="unread <= 0 && total > 0" class="ml-3 text-xs text-secondary">{{ total }}</span>
</a>
